import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import {Link, useLocation} from "react-router-dom";

const Leftbar = () => {
    const { t } = useTranslation();
    const [activeMenu, setActiveMenu] = useState(1);
    const location = useLocation();
    useEffect(() => {
        const menuMap = {
            1: ['/company'],
            2: ['/company-head'],
            3: ['/operation-area'],
            4: ['/company-power'],
            5: ['/company-documents'],
            6: ['/company-services'],
            7: ['/complaints'],
        };

        const matched = Object.entries(menuMap).find(([menuId, paths]) =>
            paths.includes(location.pathname)
        );

        if (matched) {
            setActiveMenu(Number(matched[0]));
        }
    }, [location.pathname]);
    return (
        <div className="left-bar">
            <div className="left-content">
                <div className="mask"></div>
                <div className="left-body">
                    <div className="text-center pt-1">
                        <h5 className="long px-5">
                            <Link to="/company" className="link1 text-light">{t('main_page')}</Link></h5>
                        <h5 className="short" style={{cursor:"pointer"}}><i className='bi bi-house'></i></h5>
                    </div>
                    <hr/>
                    <div>
                        <div>
                            <Link to="/company" className={activeMenu === 1? "active link2 p-2" : "link2 p-2"}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-buildings"></i>
                                    </div>
                                    <div className="long pe-3">{t('my_company')}</div>
                                </div>
                            </Link>
                        </div>
                        <div>
                            <Link to="/company-head" className={`link2 p-2 ${activeMenu === 2 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-person-vcard"></i>
                                    </div>
                                    <div className="long pe-3">{t('company_header')}</div>
                                </div>
                            </Link>
                        </div>

                        <div>
                            <Link to="/operation-area" className={`link2 p-2 ${activeMenu === 3 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-geo-alt-fill"></i>
                                    </div>
                                    <div className="long pe-3">{t('operation-area')}</div>
                                </div>
                            </Link>
                        </div>
                        <div>
                            <Link to="/company-power" className={`link2 p-2 ${activeMenu === 4 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-lightning-fill"></i>
                                    </div>
                                    <div className="long pe-3">{t('company-power')}</div>
                                </div>
                            </Link>
                        </div>

                        <div>
                            <Link to="/company-documents" className={`link2 p-2 ${activeMenu === 5 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-folder2-open"></i>
                                    </div>
                                    <div className="long pe-3">{t('company-documents')}</div>
                                </div>
                            </Link>
                        </div>
                        <div>
                            <Link to="/company-services" className={`link2 p-2 ${activeMenu === 6 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon">
                                        <i className="bi bi-tools"></i>
                                    </div>
                                    <div className="long pe-3">{t('company-services')}</div>
                                </div>
                            </Link>
                        </div>

                        <div>
                            <Link to="/complaints" className={`link2 p-2 ${activeMenu === 7 ? 'active' : ''}`}>
                                <div className="d-flex align-items-center">
                                    <div className="left-menu-icon" style={{position: "relative"}}>
                                        <i className="bi bi-envelope-exclamation"></i>
                                    </div>
                                    <div className="long pe-3">{t('complaints')}</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Leftbar;